import React from "react";
import {
    Navigate,
} from "react-router-dom";

const FileListComponent = React.lazy(() => import("../../../../../components/storage-file/components/show/page"));

export const fileRoutes = [
    {
        path: 'show',
        element: <FileListComponent />
    },
    {
        path: '',
        element: <Navigate replace to="/administration/files/show" />
    },
];